import View from './View'
import { createDOM } from './helpers/DOMHelper'
import { loadImages } from './helpers/ThreeLoaderHelper'
import { ease, Easing } from './helpers/EaseHelper'

/**
 * class Chapter
 */

export const STATE_CHAPTER_SHOW = 'chapter--show'
export const STATE_CHAPTER_HIDE = 'chapter--hide'
const SHOW_PIC_DELAY = 250
const SHOW_CHAPTER_TEXT_DELAY = 0

class Chapter extends View {
  /**
   * constructor
   */
  constructor (el, onStateChange) {
    super(el, onStateChange)
    this.textChapterId = createDOM('p', 'chapter__num text__chapter--hand')
    this.textChapterName = createDOM('p', 'chapter__name text__chapter')
    this.imgWrapper = createDOM('div', 'chapter__pics')
    this.view.appendChild(this.textChapterId)
    this.view.appendChild(this.textChapterName)
    this.view.appendChild(this.imgWrapper)
    this.state = STATE_CHAPTER_HIDE
    this.images = []
    this.chapterImages = null
  }

  preload (urls, onProgress=()=>{}) {
    return new Promise(resolve => {
      let loadingCount = urls.length
      let totalLoaded = 0
      let totalTotal = 0
      const loadings = []
      const onChapterProgress = index => (progress, loaded, total) => {
        loadings[index].push({progress, loaded, total})
        totalLoaded = loadings[index].reduce((acc, obj) => acc + obj.loaded, 0)
        totalTotal = loadings[index].reduce((acc, obj) => acc + obj.total, 0)
        onProgress(totalLoaded, totalTotal)
      }
      const onComplete = index => imgs => {
        this.images[index] = imgs
        loadingCount--
        checkComplete()
      }
      const checkComplete = () => {
        if (loadingCount === 0) resolve()
      }
      urls.map((chapterImages, index) => {
        loadImages(chapterImages, onChapterProgress).then(onComplete(index))
        return true
      })
    })
  }

  display (num, name) {
    this.textChapterId.innerHTML = `chapter ${num}`
    this.textChapterName.innerHTML = `${name}`
    this.textChapterName.style._letterSpacing = 6
    this.textChapterId.style.opacity = 0
    this.textChapterName.style.opacity = 0
    this.chapterImages = this.images[num - 1]
    this.imgWrapper.innerHTML = ''
    this.chapterImages.map(img => {
      if (!img) return false
      img.style.opacity = 0
      this.imgWrapper.appendChild(img)
      return img
    })
    this.show()
  }

  showPic (index) {
    const img = this.chapterImages[index]
    const update = props => {
      if (!img) return
      img.style.transform = `translate3d(${props.x}px, ${props.y}px, ${props.z}px)`
      img.style.opacity = (1 - Math.abs(props.opacityInvert)) * 0.25
    }
    const screenW = window.innerWidth
    const screenH = window.innerHeight
    const imgW = img.clientWidth
    const imgH = img.clientHeight
    const offsetX = Math.sin(Math.random() * 2 * Math.PI) * screenW * 0.2
    const offsetY = Math.sin(Math.random() * 2 * Math.PI) * screenH * 0.2
    ease({
      x: -imgW * 0.5 - offsetX,
      y: screenH * 0.5 - imgH * 0.5 - offsetY,
      z: -Math.random() * 3,
      opacityInvert: -1
    }).to({
      z: Math.random() * 3,
      opacityInvert: 1
    }, 700).onUpdate(update)
      .start()
    if (this.state === STATE_CHAPTER_HIDE) return
    setTimeout(() => this.showPic((index + 1) % this.chapterImages.length), SHOW_PIC_DELAY)
  }

  showHandler (resolve) {
    ease(this.textChapterId.style)
      .delay(SHOW_CHAPTER_TEXT_DELAY)
      .to({opacity: 1}, 2000)
      .start()
    ease(this.textChapterName.style)
      .delay(SHOW_CHAPTER_TEXT_DELAY)
      .to({opacity: 1}, 1000)
      .easing(Easing.Cubic.In)
      .start()
    ease(this.textChapterName.style)
      .delay(SHOW_CHAPTER_TEXT_DELAY - 100)
      .to({_letterSpacing: 8}, 5000)
      .easing(Easing.Quadratic.Out)
      .onUpdate(o => {
        this.textChapterName.style.letterSpacing = `${this.textChapterName.style._letterSpacing}rem`
        this.textChapterName.style.paddingLeft = `${this.textChapterName.style._letterSpacing}rem`
      })
      .start()
    this.state = STATE_CHAPTER_SHOW
    setTimeout(() => this.showPic(0), SHOW_CHAPTER_TEXT_DELAY - 200)
    resolve()
  }

  hideHandler (resolve) {
    ease(this.textChapterId.style)
      .to({opacity: 0}, 1000)
      .start()
    ease(this.textChapterName.style)
      .delay(500)
      .to({opacity: 0}, 1000)
      .onComplete(() => {
        this.state = STATE_CHAPTER_HIDE
        resolve()
      })
      .start()
  }
}
export default Chapter


// WEBPACK FOOTER //
// ./src/scripts/Chapter.js